// Definitions
interface Slug {
  current?: string;
}

interface ImageAsset {
  _ref?: string;
  _id?: string;
}

interface Source {
  asset?: ImageAsset;
  crop?: any;
  hotspot?: any;
}

interface Block {
  _type: string;
  children?: Array<{ text: string }>;
}

// Functions
export function cn(...args: (string | boolean | undefined | null)[]): string {
  return args.filter(Boolean).join(" ");
}

export function getUrl(slug: Slug | string | undefined | null, type?: string): string | null {
  if (!slug) {
    return null;
  }
  const slugString = typeof slug === "string" ? slug : slug.current;
  return `/${type ? `${type}/` : ''}${slugString || ''}/`;
}

export function buildImageObj(source: Source = { asset: {} }): Record<string, any> {
  const safeSource = source || {};
  const safeAsset = safeSource.asset || {};

  const imageObj: Record<string, any> = {
    asset: { _ref: safeAsset._ref || safeAsset._id || '' },
  };

  if (safeSource.crop) imageObj.crop = safeSource.crop;
  if (safeSource.hotspot) imageObj.hotspot = safeSource.hotspot;

  return imageObj;
}

export function toPlainText(blocks: Block[] | undefined | null): string {
  if (!blocks) {
    return "";
  }
  return blocks
    .map((block) => {
      if (block._type !== "block" || !block.children) {
        return "";
      }
      return block.children.map((child) => child.text).join("");
    })
    .join("\n\n");
}

export function handleize(string: string): string {
  return string
    .toLowerCase()
    .replace(/[^a-z0-9_\s-]/g, "")
    .replace(/[\s-]+/g, " ")
    .replace(/[\s_]/g, "-");
}

export function titleize(string: string): string {
  string = string.replace("-", " ");
  return string;
}

export function useDebounce<T extends (...args: any[]) => void>(func: T, delay: number): (...args: Parameters<T>) => void {
  let handler: number;
  return (...args: Parameters<T>) => {
    clearTimeout(handler);
    handler = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export function getCleanPathname(href: string | undefined | null): string | null {
  if (!href) return null;
  const url = new URL(href, window.location.origin);
  return url.pathname;
}
